'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) {
var arguments$1 = arguments;
 for (var i = 1; i < arguments.length; i++) { var source = arguments$1[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _form = require('../form');

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmTerms = function (_Component) {
	_inherits(ConfirmTerms, _Component);

	function ConfirmTerms(props) {
		_classCallCheck(this, ConfirmTerms);

		var _this = _possibleConstructorReturn(this, (ConfirmTerms.__proto__ || Object.getPrototypeOf(ConfirmTerms)).call(this, props));

		_this.state = {
			terms: _this._transformStoresFromProps.bind(_this)(_this.props)
		};

		_this.termOptions = _this.getTermOptions();

		_this.renderTerms = _this._renderTerms.bind(_this);
		_this.renderTermVariables = _this._renderTermVariables.bind(_this);
		_this.handleSetTerm = _this._handleSetTerm.bind(_this);
		_this.handleVariableChange = _this._handleVariableChange.bind(_this);
		_this.handleSubmit = _this._handleSubmit.bind(_this);
		_this.isValid = _this._isValid.bind(_this);
		return _this;
	}

	_createClass(ConfirmTerms, [{
		key: '_transformStoresFromProps',
		value: function _transformStoresFromProps(props) {

			if (!props.terms) return [];

			var termsFromProps = [].concat(_toConsumableArray(props.terms));
			termsFromProps.sort();
			var terms = [];
			for (var i = 0; i < termsFromProps.length; i++) {
				terms.push({
					label: termsFromProps[i],
					term: '',
					variables: {}
				});
			}

			return terms;
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.setState({
				terms: this._transformStoresFromProps.bind(this)(nextProps)
			});
		}
	}, {
		key: 'getTermOptions',
		value: function getTermOptions() {
			var keys = Object.keys(PAYMENT_TERMS);
			var terms = [];
			for (var i = 0; i < keys.length; i++) {
				terms.push({
					value: PAYMENT_TERMS[keys[i]].slug,
					label: PAYMENT_TERMS[keys[i]].name
				});
			}
			return terms;
		}
	}, {
		key: 'render',
		value: function render() {

			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)("confirm-terms import-data-validation", { showErrors: this.state.showErrors }) },
				_react2.default.createElement(
					'div',
					{ className: 'title' },
					'Confirm Terms'
				),
				_react2.default.createElement(
					'div',
					{ className: 'sub-title' },
					"We couln't figure out the payment terms. Please select the correct payment term and add any relevant parameters."
				),
				_react2.default.createElement(
					'div',
					{ className: 'terms' },
					this.renderTerms()
				),
				_react2.default.createElement(
					'div',
					{ className: 'btn btn-warning pull-right' },
					'Reset Import'
				),
				_react2.default.createElement(
					'div',
					{ className: 'btn btn-success', onClick: this.handleSubmit, tabIndex: '0' },
					'Confirm'
				),
				_react2.default.createElement(
					'div',
					{ className: 'error' },
					'Please select the corresponding term and enter the correct variables for each payment term.'
				)
			);
		}
	}, {
		key: '_renderTerms',
		value: function _renderTerms() {
			var _this2 = this;

			var terms = this.state.terms;


			return terms.map(function (term, index) {
				return _react2.default.createElement(
					'div',
					{ className: 'term', key: term.label },
					_react2.default.createElement(
						'div',
						{ className: 'term-label' },
						term.label
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)("term-select", { empty: !term.term }) },
						_react2.default.createElement(_reactSelect2.default, {
							options: _this2.termOptions,
							value: term.term,
							onChange: _this2.handleSetTerm.bind(null, index),
							clearable: false
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'term-variables' },
						_this2.renderTermVariables(term, index)
					)
				);
			});
		}
	}, {
		key: '_renderTermVariables',
		value: function _renderTermVariables(term, termIndex) {
			var _this3 = this;

			if (!term.term) return null;

			var termDef = PAYMENT_TERMS[term.term];

			return termDef.variables.map(function (variable, index) {

				var value = term.variables[variable.slug] || '';

				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)("term-variable var-" + variable.slug, { empty: !value }), key: variable.slug + termIndex },
					_react2.default.createElement(
						'label',
						{ htmlFor: variable.slug + termIndex },
						variable.name
					),
					_react2.default.createElement('input', { type: 'text', value: value, onChange: _this3.handleVariableChange.bind(null, variable.slug, termIndex) })
				);
			});
		}
	}, {
		key: '_handleSetTerm',
		value: function _handleSetTerm(index, newValue) {

			var terms = [].concat(_toConsumableArray(this.state.terms));
			terms[index] = _extends({}, terms[index], {
				term: newValue.value
			});

			this.setState({
				terms: terms
			});
		}
	}, {
		key: '_handleVariableChange',
		value: function _handleVariableChange(slug, index, event) {

			var value = event.target.value;
			value = value.replace(/[^0-9\.]/g, '');

			var terms = [].concat(_toConsumableArray(this.state.terms));
			terms[index].variables[slug] = value;

			this.setState({
				terms: terms
			});
		}
	}, {
		key: '_handleSubmit',
		value: function _handleSubmit() {
			var _this4 = this;

			if (!this.isValid()) {

				this.setState({
					showErrors: true
				});
				console.log('not valid');
				return;
			}

			this.setState({
				submitting: true
			});

			console.log('posting');

			_request2.default.post({
				url: location.origin + '/ajax/import/terms',
				form: {
					_token: CSRF_TOKEN,
					terms: this.state.terms
				}
			}, function (err, res, body) {
				if (err) {
					console.log(err);
				} else {
					console.log(body);
					_this4.props.onDone();
				}
			});
		}
	}, {
		key: '_isValid',
		value: function _isValid() {
			var terms = this.state.terms;


			for (var i = 0; i < terms.length; i++) {
				if (!terms[i].term) return false;
				var variables = PAYMENT_TERMS[terms[i].term].variables;
				for (var j = 0; j < variables.length; j++) {
					if (typeof terms[i].variables[variables[j].slug] === 'undefined' || terms[i].variables[variables[j].slug] === '') return false;
				}
			}

			return true;
		}
	}]);

	return ConfirmTerms;
}(_react.Component);

exports.default = ConfirmTerms;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/data/ConfirmTerms.js
// module id = 565
// module chunks = 0